<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <MembersForm :baseMember="member" :baseMemberName="name" :loading="loading" @submit-requested="submitRequested"></MembersForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MembersForm from './MembersForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            member: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { MembersForm },
    computed:
    {
        ...mapState('members', ['getMemberDetailsOutput']),
    },
    methods: {
        ...mapActions('members', ['getMemberDetails']),
        ...mapActions('members', ['putMember']),
        submitRequested(member) {
            this.putMember(member);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'MembersList' });
        }

        this.getMemberDetails(this.$route.query.id);
    },
    watch:
    {
        getMemberDetailsOutput: function(memberOutput)
        {
            if(!memberOutput && !memberOutput.data)
            {
                router.push({ name: 'MembersList' });
            }
            else
            {
                this.member = memberOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>